import { apiPost } from '@/api/api.ts'
import { ITestSession, TestSessionKind } from '@/api/user/getActiveTestSessions.ts'

export const apiStartTestSession = async (protecteeId: number, kind: TestSessionKind = 'emergency') => {
    return await apiPost<ITestSession>(`/protectee/${protecteeId}/test-session`, { kind })
}
